<template>
  <div class="corpo-pagina">

        <div id="reportsend" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">send</i>
          {{ translation('app.igotu.mobile.titolo.mail') }}
        </h4>
        <p>{{ translation('app.igotu.mobile.msg.alert.report') }}</p>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModal()" class="modal-close btn-large">
          OK
        </a>
      </div>
    </div>

    <div class="row row-text">
      <div class="col s12">
        <h4>{{ translation('guest.list.imported') }}</h4>
      </div>
    </div>
    <div class="divider"></div>

    <div class="row">
      <div class="col s12 m4 l4">
        <router-link class="btn-small red ml-2" to="/form-guest"><i v-red-tooltip="translation('Igotu.68')"
            class="material-icons">add_circle_outline</i></router-link>

        <a href="javascript:void(0)" class="btn-small red ml-2" @click="goToImportGuests">
          <i v-red-tooltip="translation('title.import.pax')" class="material-icons">
            cloud_upload
          </i>
        </a>

        <!-- span v-red-tooltip="translation('btn.dowload.xls.pax')">
          <JsonExcel class="btn-small red ml-2" :data="exportedGuests" :fields="jsonFields" :name="this.nameFile">
            <i class="material-icons">file_download</i>
          </JsonExcel>
          </span -->

           <a href="javascript:void(0)" class="btn-small red ml-2" @click="exportedGuests">
          <i v-red-tooltip="translation('app.igotu.mobile.btn.invia.report')" class="material-icons">
            file_download
          </i>
        </a>

      </div>

      <div class="col s12 m4 l4">
      </div>

      <div class="input-field col s12 m4 l4">
        <i class="material-icons prefix">search</i>
        <input id="search" type="text" v-model="searchTerm" @input="resetPage">
        <label for="search">{{ translation('Igotu.46') }}</label>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <table class="striped responsive-table">
          <thead>
            <tr>
              <th style="width: 15%;">{{ translation('label.surname.pax') }}</th>
              <th style="width: 15%;">{{ translation('label.name.pax') }}</th>

              <th style="width: 15%;">{{ translation('label.email.pax') }}</th>

              <th v-for="(fieldLabel, index) in customFieldLabels" :key="index">
                {{ fieldLabel }}
              </th>

              <th style="width: 5%;">{{ translation('accompanying.persons.number') }}</th>
              <th style="width: 15%;">{{ translation('status.pax.subscription') }}</th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="paginatedGuests.length === 0">
              <td :colspan="6 + customFieldLabels.length">
                {{ searchTerm ? translation('guest.noResultsFound') : translation('guest.noGuestsFound') }}
              </td>
            </tr>
            <tr v-for="guest in paginatedGuests" :key="guest.id">
              <td>{{ guest.surname }}</td>
              <td>{{ guest.name }}</td>

              <td>{{ guest.email }}</td>

              <td v-for="(labelName, index) in customFieldLabels" :key="index">
                {{ guest.attributes && guest.attributes[labelName] ? guest.attributes[labelName] : '-' }}
              </td>
              <td style="text-align: center;">{{ guest.accompanying_persons }}</td>
              <td>{{ translation(guest.status_name.name_status) }}</td>
              <td style="text-align: right;">
                <a href="#!" v-red-tooltip="translation('btn.menu.pax.modify')" @click="goEditPage(guest)"
                  class="btn-small blue">
                  <i class="material-icons">edit</i>
                </a>
                <a href="#!" v-red-tooltip="guest.status_name.name_status.toLowerCase() === 'confirmed'
                  ? translation('btn.menu.pax.delete')
                  : translation('btn.menu.pax.undo')" @click="deletePax(guest)" class="btn-small red ml-2">
                  <i v-if="guest.status_name.name_status.toLowerCase() === 'confirmed'" class="material-icons">
                    delete
                  </i>
                  <i v-else class="material-icons">
                    undo
                  </i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <PaginationControls :current-page="currentPage" :total-pages="totalPages" :items-per-page="itemsPerPage"
          :str-per-pag="translation('pagination.itemsPerPage')" :str-pag="translation('pagination.page')"
          @page-changed="handlePageChange" @items-per-page-changed="handleItemsPerPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
// import JsonExcel from 'vue-json-excel' // Importa la libreria
import PaginationControls from '@/components/PaginationControls.vue'
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import eventSetting from '@/store/eventSettings.js'
import M from 'materialize-css'
import apiService from '@/services/apiService.js'

export default {
  name: 'GuestListPage',
  components: {
    PaginationControls
    // JsonExcel // Registra localmente
  },
  data () {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      searchTerm: '',
      // guestDelete: null,
      deleteModalInstance: null,
      eventSetting: eventSetting,
      nameFile: null,
      localGuests: []
    }
  },
  computed: {
    translation () {
      return translationStore.getters.traduzione
    },
    fullEventData () {
      return eventSetting.getters.eventModel || {}
    },
    eventLabels () {
      return this.fullEventData.event_labels || []
    },
    customFieldMap () {
      const map = new Map()
      this.eventLabels
        .filter(lbl => lbl.showInApp)
        .forEach(lbl => map.set(lbl.field, lbl.name))
      return map
    },
    customFieldLabels () {
      return this.eventLabels
        .filter(lbl => lbl.showInApp) // 🔥 SOLO SHOW IN APP
        .map(lbl => lbl.name)
    },

    filteredGuests () {
      const guests = this.localGuests || []
      const searchTermLower = this.searchTerm.toLowerCase().trim()

      if (!searchTermLower) {
        return guests
      }

      const filtered = guests.filter(guest => {
        if (!guest) {
          return false
        }

        const nameMatch = guest.name ? guest.name.toLowerCase().includes(searchTermLower) : false
        const surnameMatch = guest.surname ? guest.surname.toLowerCase().includes(searchTermLower) : false
        const emailMatch = guest.email ? guest.email.toLowerCase().includes(searchTermLower) : false
        const notesMatch = guest.notes ? guest.notes.toLowerCase().includes(searchTermLower) : false

        const customFieldMatch = this.customFieldLabels.some(labelName => {
          const fieldValue = guest.attributes && guest.attributes[labelName]
          return fieldValue ? String(fieldValue).toLowerCase().includes(searchTermLower) : false
        })
        return nameMatch || surnameMatch || emailMatch || notesMatch || customFieldMatch
      })

      return filtered
    },
    totalPages () {
      const pages = Math.ceil(this.filteredGuests.length / this.itemsPerPage)
      return pages
    },
    paginatedGuests () {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      const paginated = this.filteredGuests.slice(startIndex, endIndex)
      return paginated
    },

    // CALCOLATO ESSENZIALE PER VUE-JSON-EXCEL: Prepara i dati
    /* exportedGuests () {
      const exportList = []

      for (const g of this.filteredGuests) {
        // -------------------------------
        // Trasforma transiti come in Flutter
        // -------------------------------
        let ingressoEventoDate = ''
        let arrivatoSalaDate = ''

        if (g.transits && g.transits.length > 0) {
          for (const t of g.transits) {
            const isMain = (t.accompaning_id ?? t.accompanying_id ?? 0) === 0

            if (!isMain) continue

            const dt = t.date_transit || t.date_transits || ''
            if (!dt) continue

            const sessionObj = t.session_id || {}
            const type = parseInt(sessionObj.type_session_id || 0)

            if (type === 1) ingressoEventoDate = dt
            if (type === 2) arrivatoSalaDate = dt
          }
        }

        // -------------------------------
        // Costruisci valori dinamici (field0..field5)
        // -------------------------------
        const dynamicValues = this.customFieldLabels.map(labelName => {
          return g.attributes && g.attributes[labelName]
            ? g.attributes[labelName]
            : ''
        })

        // -------------------------------
        // ROW PRINCIPALE
        // -------------------------------
        const mainRow = {
          surname: g.surname || '',
          name: g.name || '',
          email: g.email || '',
          notes: g.notes || '',
          ...Object.fromEntries(
            this.customFieldLabels.map((labelName, idx) => [
              `dynamic_${idx}`, dynamicValues[idx]
            ])
          ),
          ingresso_evento: ingressoEventoDate,
          arrivo_sala: arrivatoSalaDate,
          accompaning_count: g.accompanying_persons ?? 0,
          accomp_name: '',
          accomp_ingresso: '',
          accomp_arrivo: ''
        }

        exportList.push(mainRow)

        // -------------------------------
        // ACCOMPAGNATORI
        // -------------------------------
        const accompCount = g.accompanying_persons ?? 0
        const accompTransits = {}

        if (g.transits && g.transits.length > 0) {
          for (const t of g.transits) {
            const id = parseInt(t.accompaning_id ?? t.accompanying_id ?? 0)
            if (id > 0) accompTransits[id] = t
          }
        }

        for (let i = 1; i <= accompCount; i++) {
          const t = accompTransits[i] || {}
          const accomName = t.accompaning_name || `Accompagnatore ${i}`

          let accIngresso = ''
          let accArrivo = ''

          const dt = t.date_transit || t.date_transits || ''
          if (dt) {
            const sessionObj = t.session_id || {}
            const type = parseInt(sessionObj.type_session_id || 0)

            if (type === 1) accIngresso = dt
            if (type === 2) accArrivo = dt
          }

          const accompRow = {
            surname: g.surname || '',
            name: g.name || '',
            email: g.email || '',
            notes: g.notes || '',
            ...Object.fromEntries(
              this.customFieldLabels.map((labelName, idx) => [
                `dynamic_${idx}`, dynamicValues[idx]
              ])
            ),
            ingresso_evento: ingressoEventoDate,
            arrivo_sala: arrivatoSalaDate,
            accompaning_count: '-',
            accomp_name: accomName,
            accomp_ingresso: accIngresso,
            accomp_arrivo: accArrivo
          }

          exportList.push(accompRow)
        }
      }

      return exportList
    }, */

    // CALCOLATO ESSENZIALE PER VUE-JSON-EXCEL: Definisce intestazioni e campi
    jsonFields () {
      const fields = {
        [this.translation('label.surname.pax')]: 'surname',
        [this.translation('label.name.pax')]: 'name',
        [this.translation('label.email.pax')]: 'email',
        [this.translation('note.field.xls')]: 'notes'
      }

      this.customFieldLabels.forEach((lbl, idx) => {
        fields[lbl] = `dynamic_${idx}`
      })

      fields[this.translation('app.igotu.mobile.titolo.report.sessione')] = 'ingresso_evento'
      fields[this.translation('app.igotu.mobile.titolo.report.sala')] = 'arrivo_sala'
      fields[this.translation('accompanying.persons.number')] = 'accompaning_count'
      fields['Acc.'] = 'accomp_name'
      fields.Ingresso = 'accomp_ingresso'
      fields.Arrivo = 'accomp_arrivo'

      return fields
    }

  },

  watch: {
    '$route' () {
      this.fetchGuests()
    }
  },

  methods: {

    openModal () {
      if (this.modal) {
        this.modal.open()
      }
    },

    closeModal () {
      if (this.modal) {
        this.modal.close()
      }
    },

    async exportedGuests () {
      const url = process.env.VUE_APP_URL_REPORTS + '/create'
      try {
        const token = await apiService.getClientCredentialsToken()

        if (token) {
          const text = this.translation('app.igotu.mobile.msg.report')
          const subj = this.translation('app.igotu.mobile.subject.report')
          const payload = { subject: subj, text: text, event_id: this.fullEventData.uid }

          const responseData = await apiService.sendRequestWithBearer('POST', url, token, payload)

          if (responseData) {
            this.openModal()
          }
        } else {
          this.$router.push('/error')
        }
      } catch (error) {
        console.error(error)
        this.$router.push('/error')
      }
    },

    goToImportGuests () {
      window.location.href = '/import-guests'
    },

    // Etrae le sessioni e date di transito per tipo 1 e tipo 2
    getTransitInfoByType (guest) {
      const result = {
        type1: { session: '-', date: '-' },
        type2: { session: '-', date: '-' }
      }

      if (!guest || !guest.transits || guest.transits.length === 0) {
        return result
      }

      guest.transits.forEach(t => {
        const typeId = t.session_id?.type_session_id
        const sessionValue = t.session_id?.uid || t.session_id?.session_id || '-'
        const dateValue = t.date_transit || t.date_transits
          ? new Date(t.date_transit || t.date_transits).toLocaleString('it-IT')
          : '-'

        if (typeId === 1) {
          result.type1 = { session: sessionValue, date: dateValue }
        } else if (typeId === 2) {
          result.type2 = { session: sessionValue, date: dateValue }
        }
      })

      return result
    },
    goEditPage (guest) {
      eventSetting.dispatch('guestEdit', guest)
      this.$router.push({
        name: 'formguestsEdit',
        params: { isNew: false }
      })
    },

    resetGuest () {
      // this.guestDelete = null
    },
    restoreScrollbar () {
      document.body.style.overflow = 'auto'
    },
    /* openModalDelete (guest) {
      this.guestDelete = guest
      /* if (this.deleteModalInstance) {
        this.deleteModalInstance.open()
      } */
    // this.cloaseModalandDelete()
    // },
    async deletePax (guest) {
      if (this.deleteModalInstance) {
        this.deleteModalInstance.close()
      }
      loadingStore.commit('setLoading', true)
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        this.$router.push('/error')
      } else {
        let statusid = 2
        if (guest.status_name.name_status.toLowerCase() !== 'confirmed') {
          statusid = 1
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/guests/' + guest.uid + '/' + statusid

        try {
          const json = await apiService.sendRequestWithBearer('DELETE', url, token, null)

          if (json && json.res === 'ok') {
            if (statusid === 2) {
              guest.status_name.name_status = 'Canceled'
            } else {
              guest.status_name.name_status = 'Confirmed'
            }

            eventSetting.dispatch('deleteGuestFromEvent', guest.uid, true)
          } else {
            this.$router.push('/error')
          }
        } catch (error) {
          this.$router.push('/error')
        } finally {
          // this.guestDelete = null
          loadingStore.commit('setLoading', false)
        }
      }
    },
    cloaseModalandNotDelete () {
      if (this.deleteModalInstance) {
        this.deleteModalInstance.close()
      }
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    handleItemsPerPageChange (newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage
      this.currentPage = 1
    },
    resetPage () {
      this.currentPage = 1
    },
    manageLoadingState () {
      loadingStore.commit('setLoading', false)
    },

    async fetchGuests () {
      const url = process.env.VUE_APP_URL_EVENTS + '/guests/list-guests-all'
      try {
        const payload = { event_id: this.fullEventData.uid }
        const token = await apiService.getClientCredentialsToken()

        if (token) {
          const responseData = await apiService.sendRequestWithBearer('POST', url, token, payload)

          if (responseData && responseData.res === 'ok') {
            // 👉 QUI aggiorni i guest in locale, NON nello store
            this.localGuests = responseData.guests
          }
        } else {
          this.$router.push('/error')
        }
      } catch (error) {
        console.error(error)
        this.$router.push('/error')
      }
    },

    // Metodo per trovare l'ultima mail e restituire stato e data
    getLastMailInfo (guest) {
      if (!guest || !guest.sended_mails || guest.sended_mails.length === 0) {
        const t1 = this.translation('export.mail.status.titolo.tabella.002')
        return { status: t1, sendDate: '-' }
      }

      // Ordina le mail per data di creazione decrescente per trovare l'ultima
      const sortedMails = [...guest.sended_mails].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })

      const lastMail = sortedMails[0]

      const status = lastMail.logMail ? lastMail.logMail.status : ' - '

      // Formatta la data se disponibile, altrimenti usa la data di creazione
      let sendDate = lastMail.logMail && lastMail.logMail.date ? new Date(lastMail.logMail.date).toLocaleString() : new Date(lastMail.createdAt).toLocaleString()

      // Se non ci sono log, usiamo la data di creazione della mail come ultima risorsa
      if (sendDate === 'Invalid Date') {
        sendDate = '-'
      }

      return { status: status, sendDate: sendDate }
    }
  },
  created () {
    this.manageLoadingState()
  },
  mounted () {
    this.manageLoadingState()
    M.updateTextFields()
    const elems = document.getElementById('deletepx')
    this.deleteModalInstance = M.Modal.init(elems, {
      onCloseEnd: () => {
        this.resetGuest()
        this.restoreScrollbar()
      },
      onOpenEnd: () => {
        this.manageLoadingState()
      }
    })

    this.nameFile = this.eventSetting.getters.nameEvent + '_GUESTS.xlsx'
    this.fetchGuests()

    const elemsModal = document.getElementById('reportsend')

    this.modal = M.Modal.init(elemsModal, {
      onCloseEnd: () => { /* ... */ },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })
  },
  beforeDestroy () {
    if (this.deleteModalInstance) {
      this.deleteModalInstance.destroy()
    }
    this.restoreScrollbar()
  }

}
</script>

<style scoped>
.corpo-pagina {
  padding: 20px;
}

table {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}

.input-field {
  margin-bottom: 20px;
}

body {
  overflow-y: auto !important;
}
</style>
